import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MeasuresFacade } from '@library/store/measures/measures.facade';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { ControlPageStore, GraphType } from '@pages/control-page/control-page-store.service';
import { combineLatest, firstValueFrom, map, switchMap } from 'rxjs';

@Component({
  selector: 'app-control-page-graph-max-wind',
  templateUrl: './control-page-graph-max-wind.component.html',
  styleUrls: ['./control-page-graph-max-wind.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlPageGraphMaxWindComponent {

  EnumMeasureTypes = EnumMeasureTypes;

  private display$ = this.controlPageStore.card$.pipe(
    isDefined(),
    map(card => card.graphType === GraphType.WIND),
  );

  private maxWind$ = this.controlPageStore.state$.pipe(
    switchMap(() => this.controlPageStore.datasets$),
    switchMap((datasets) => this.measuresFacade.getModulesMeasures(
      datasets.filter(d => d.module).map(d => d.module)
    )),
    switchMap(async ([measures]) => {
      const scale = await firstValueFrom(this.controlPageStore.scale$);
      const apiScale = this.controlPageStore.scaleToApiScale(scale);
      const timeRange = await firstValueFrom(this.controlPageStore.timeRange$);
      const xMin = timeRange.dateBegin.valueOf();
      const xMax = timeRange.dateEnd.valueOf();
      return measures?.GustStrength?.[apiScale]
        .filter(m => m.x >= xMin && m.x <= xMax)
        .reduce((acc, curr) => curr.y > acc ? curr.y : acc, 0) ?? 0;
    })
  );

  viewModel$ = combineLatest({
    display: this.display$,
    maxWind: this.maxWind$,
  });

  constructor(
    private controlPageStore: ControlPageStore,
    private measuresFacade: MeasuresFacade,
  ) {}
}
